import { useNotifications } from '../../../state/modules/notifications'

export const useProgressToast = () => {
  const { send, dismiss } = useNotifications()

  const startProgress = (title: string, message: string): string =>
    send({ title, message, persistent: true, useRucksackUI: true })

  const endProgress = (toastId: string | undefined) => {
    if (toastId) {
      dismiss(toastId)
    }
  }

  return { startProgress, endProgress }
}
